module.exports = __webpack_public_path__ + "img/9788998317645.4b0e3ee1.jpg";